import React, { Component, Fragment } from "react";
import RejectModel from "./RejectModel";
import AppContext from "../../../contexts/AppContext";
import AcceptModel from "./AcceptModel";

class Invitation extends Component {
    state = {
        reject: false,
        accept: false,
        item: {}
    };

    /* delete */
    accept = () => {
        return this.props.accept(this.props.item.invitation_id).then(res => {
            this.toggleAccept();
        });
    };

    toggleAccept = () => {
        this.setState({ accept: this.state.accept === true ? false : true });
    };
    /* create */
    reject = () => {
        return this.props.reject(this.props.item.invitation_id).then(res => {
            this.toggleReject();
        });
    };
    toggleReject = () => {
        this.setState({ reject: this.state.reject === true ? false : true });
    };

    render() {
        return (
            <Fragment>
                <tr>
                    <td>{this.props.item.id}</td>
                    <td>
                        <a
                            target="_blank"
                            href={`/jobs/job/${this.props.item.job.link}`}
                        >
                            {this.props.item.job.title}
                        </a>
                    </td>
                    <td>
                        <time dateTime={this.props.item.created_at}>
                            {this.props.item.created_at}
                        </time>
                    </td>

                    <td className="text-center">
                        {this.props.item.state === "pending" ? (
                            <Fragment>
                                <button
                                    onClick={this.toggleReject}
                                    type="button"
                                    className="btn btn-danger btn-sm ml-2"
                                >
                                    Reject
                                </button>
                                <button
                                    onClick={this.toggleAccept}
                                    type="button"
                                    className="btn btn-primary btn-sm ml-2"
                                >
                                    Accept
                                </button>
                            </Fragment>
                        ) : (
                            this.props.item.state
                        )}
                    </td>
                </tr>
                {this.state.reject === true ? (
                    <RejectModel
                        reject={this.reject}
                        hide={this.toggleReject}
                    ></RejectModel>
                ) : null}
                {this.state.accept === true ? (
                    <AcceptModel
                        accept={this.accept}
                        hide={this.toggleAccept}
                    ></AcceptModel>
                ) : null}
            </Fragment>
        );
    }
}
Invitation.contextType = AppContext;
export default Invitation;



// WEBPACK FOOTER //
// ./src/components/writer/clients/Invitation.js